import React, { useContext, useEffect, useState } from "react";

// styles
import styles from "../UserFilesDetail.module.css";

//Images
import bedIcon from "../../../../assets/img/DashboardICons/bedIcon.svg";
import meterIcon from "../../../../assets/img/DashboardICons/meterIcon.svg";
import buildingIcon from "../../../../assets/img/DashboardICons/buildingIcon.svg";
import locationIcon from "../../../../assets/img/DashboardICons/locationIcon.svg";
import calenderIcon from "../../../../assets/img/DashboardICons/CalenderIcon.svg";
import CardChart from "../../../Dashboard/DashboardFileManagement/CardDetail/CardChart";
import FileFacilities from "../../../Dashboard/DashboardFileManagement/CardDetail/FileFacilities";
import parse from "html-react-parser";
import { UserContext } from "../../../Context/UserContextProvider";
import axios from "axios";

const UserFilesDetailFacilities = props => {
  console.log("props", props);
  const e2p = s => s?.toString()?.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
  const { userToken, userData, permissions } = useContext(UserContext);

  let [categories, setCategories] = useState([]);

  useEffect(() => {
    axios
      .get("Category", {
        headers: {
          authorization: "Bearer " + userToken,
        },
      })
      .then(res => {
        setCategories(res.data?.data || []);
      });
  }, []);

  const shopCategories = [304, 280];
  const hotelCategories = [278, 291];
  const gasStationCategories = [309, 316];
  const landCategories = [273, 277, 281, 284, 287, 302, 305, 308, 312, 315, 517];
  const industrialCategories = [311, 312, 313, 314, 318, 319, 320, 321];

  function getCategoryParent() {
    let selectedCategory = categories.find(c => c.id == props.data?.categoryId);

    return selectedCategory?.parentId;
  }

  function getShopFields() {
    return (
      <>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ کف مغازه</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterageBase)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ دهنه</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterageGate)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ بالکن</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterageBalkony)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>انبار تجاری</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.commercialStorage)}</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>ارتفاع سقف</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.ceilingHeight)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>ارتفاع سقف</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.ceilingHeight)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={calenderIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>سال ساخت</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.constructionYear?.toString())}</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              style={{
                height: "20px",
                width: "20px",
                filter: "brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(144%) hue-rotate(221deg) brightness(97%) contrast(87%);",
              }}>
              <path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z" />
            </svg>
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.text_gray}>تعداد طبقه</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.totalFloors)}</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              style={{
                height: "20px",
                width: "20px",
                filter: "brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(144%) hue-rotate(221deg) brightness(97%) contrast(87%);",
              }}>
              <path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z" />
            </svg>
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}> طبقه</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.floors)}</span>
          </div>
        </div>
      </>
    );
  }

  function getHotelFields() {
    return (
      <>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ بنا</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterageBase)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ زمین</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterage)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={calenderIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>سال ساخت</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.constructionYear?.toString())}</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              style={{
                height: "20px",
                width: "20px",
                filter: "brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(144%) hue-rotate(221deg) brightness(97%) contrast(87%);",
              }}>
              <path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z" />
            </svg>
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.text_gray}>تعداد طبقه</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.totalFloors)}</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
              style={{
                height: "20px",
                width: "20px",
                filter: "brightness(0) saturate(100%) invert(58%) sepia(0%) saturate(144%) hue-rotate(221deg) brightness(97%) contrast(87%);",
              }}>
              <path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z" />
            </svg>
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}> طبقه</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.floors)}</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={bedIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>تعداد اتاق</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.roomCount)}</span>
          </div>
        </div>
      </>
    );
  }

  function getGasStationFields() {
    return (
      <>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ بنا</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterageBase)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ زمین</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterage)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={calenderIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>سال ساخت</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.constructionYear?.toString())}</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={calenderIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>تعداد نازل</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.pumpCount)}</span>
          </div>
        </div>
      </>
    );
  }

  function getLandFields() {
    return (
      <>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ بنا</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterageBase)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>متراژ زمین</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.meterage)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>عرض گذر</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.walkawayWidth)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>عرض ملک</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.landWidth)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={meterIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>طول ملک</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.landHeight)} متر</span>
          </div>
        </div>
        <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
          <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
            <img src={calenderIcon} alt="icon" />
          </div>
          <div className="d-flex align-items-start justify-content-center flex-column me-3">
            <span className={styles.card_main_detail_text1}>سال ساخت</span>
            <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.constructionYear?.toString())}</span>
          </div>
        </div>
      </>
    );
  }

  function copyLink() {
    let url = window.location.href;

    navigator.clipboard.writeText(decodeURI(url)).then(() => {
      alert("لینک اشتراک کپی شد!");
    });
  }

  return (
    <>
      <div className={`${props.w100 ? "w-100" : "w-75"} d-flex flex-column justify-content-center align-items-center ${styles.container_main_box}`} dir="rtl">
        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
          <div className={styles.file_title}>
            {props.limitedFields?.find(item => item === "Title") ? (
              <></>
            ) : (
              <div className="d-flex align-items-center justify-content-center mt-2">
                <div className={styles.title}>
                  <div className={`${styles.link}`} onClick={copyLink}>
                    <p>اشتراک گذاری</p>
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width={20} height={20}>
                        <path d="M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z" />
                      </svg>
                    </div>
                  </div>
                  {props.data?.title}
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
          {props.data?.totalPrice || categories?.find(c => c.id == props?.data?.categoryId)?.dealType != 1 ? (
            <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap p-3 ${styles.pricesdata_container}`}>
              {props.limitedFields?.find(item => item === "TotalPrice") ? (
                <></>
              ) : (
                <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                  <div className={`ms-2 ${styles.text_gray}`}>قیمت کل:</div>
                  <div className={styles.text_title}>{e2p(props.data?.totalPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                  <span className={`me-1 ${styles.text_gray}`}>تومان</span>
                </div>
              )}
              {props.limitedFields?.find(item => item === "MeteragePrice") ? (
                <></>
              ) : (
                <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                  <div className={`ms-2 ${styles.text_gray}`}>قیمت هر متر:</div>
                  <div className={styles.text_title_sm}>
                    {e2p(props.data?.meteragePrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))} تومان هر متر مربع
                  </div>
                </div>
              )}

              <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                <div className={styles.text_gray}>تعداد واحد در هر طبقه :</div>
                <div className={styles.text_title_sm}>{e2p(props.data?.unitsNumber ? props.data?.unitsNumber : 0)}</div>
              </div>

              <div className="w-100 d-flex align-items-center justify-content-start mt-3 mb-3 mx-md-0 mx-2">
                <div className={`ms-2 ${styles.text_gray}`}>آدرس حدودی:</div>
                <div className={styles.text_title_sm}>{e2p(props.data?.address.shortAddress)}</div>
              </div>
            </div>
          ) : (
            <div className={`w-100 d-flex align-items-center justify-content-between flex-wrap p-3 ${styles.pricesdata_container}`}>
              {props.limitedFields?.find(item => item === "MortgagePrice") ? (
                <></>
              ) : (
                <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                  <div className={`ms-2 ${styles.text_gray}`}>رهن:</div>
                  <div className={styles.text_title}>{e2p(props.data?.mortgagePrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                  <span className={`me-1 ${styles.text_gray}`}>تومان</span>
                </div>
              )}
              {props.limitedFields?.find(item => item === "RentPrice") ? (
                <></>
              ) : (
                <div className="d-flex align-items-center justify-content-center mt-3 mb-3 mx-md-0 mx-2">
                  <div className={`ms-2 ${styles.text_gray}`}>اجاره ماهانه:</div>
                  <div className={styles.text_title}>{e2p(props.data?.rentPrice?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"))}</div>
                  <span className={`me-1 ${styles.text_gray}`}>تومان</span>
                </div>
              )}

              <div className="w-100 d-flex align-items-center justify-content-start mt-3 mb-3 mx-md-0 mx-2">
                <div className={`ms-2 ${styles.text_gray}`}>آدرس حدودی:</div>
                <div className={styles.text_title_sm}>{e2p(props.data?.address.fullAddress)}</div>
              </div>
            </div>
          )}
        </div>

        {props.consultantInfo}

        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
          {/* <div className='w-100 d-flex align-items-center justify-content-center flex-wrap mt-3 mb-2 px-3'> */}
          <hr className="solid w-100" />
          <div
            className="w-100 d-flex align-items-center justify-content-md-between justify-content-center flex-wrap mt-2 mb-2 px-3"
            style={{ rowGap: "10px" }}>
            {shopCategories.includes(getCategoryParent()) ? (
              getShopFields()
            ) : hotelCategories.includes(getCategoryParent()) ? (
              getHotelFields()
            ) : gasStationCategories.includes(getCategoryParent()) ? (
              getGasStationFields()
            ) : landCategories.includes(getCategoryParent()) ? (
              getLandFields()
            ) : (
              <></>
            )}
            {props.limitedFields?.find(item => item === "RoomCount") ||
            shopCategories.includes(getCategoryParent()) ||
            shopCategories.includes(getCategoryParent()) ||
            hotelCategories.includes(getCategoryParent()) ||
            gasStationCategories.includes(getCategoryParent()) ||
            landCategories.includes(getCategoryParent()) ? (
              <></>
            ) : (
              <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                  <img src={bedIcon} alt="icon" />
                </div>
                <div className="d-flex align-items-start justify-content-center flex-column me-3">
                  <span className={styles.text_gray}>تعداد اتاق</span>
                  <span className={`me-0 mt-1 ${styles.text_title_sm}`}>{e2p(props.data?.roomCount?.toString())} خوابه</span>
                </div>
              </div>
            )}

            {props.limitedFields?.find(item => item === "Meterage") ||
            shopCategories.includes(getCategoryParent()) ||
            shopCategories.includes(getCategoryParent()) ||
            hotelCategories.includes(getCategoryParent()) ||
            gasStationCategories.includes(getCategoryParent()) ||
            landCategories.includes(getCategoryParent()) ? (
              <></>
            ) : (
              <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                  <img src={meterIcon} alt="icon" />
                </div>
                <div className="d-flex align-items-start justify-content-center flex-column me-3">
                  <span className={styles.text_gray}>متراژ کل</span>
                  <span className={`me-0 mt-1 ${styles.text_title_sm}`}>{e2p(props.data?.meterage?.toString())} متر</span>
                </div>
              </div>
            )}

            {props.limitedFields?.find(item => item === "Floor") ||
            shopCategories.includes(getCategoryParent()) ||
            shopCategories.includes(getCategoryParent()) ||
            hotelCategories.includes(getCategoryParent()) ||
            gasStationCategories.includes(getCategoryParent()) ||
            landCategories.includes(getCategoryParent()) ? (
              <></>
            ) : (
              <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                  <img src={buildingIcon} alt="icon" />
                </div>
                <div className="d-flex align-items-start justify-content-center flex-column me-3">
                  <span className={styles.text_gray}>طبقه</span>
                  <span className={`me-0 mt-1 ${styles.text_title_sm}`}>
                    {props.data?.floor == "0" ? "همکف" : props.data?.floor == "-1" ? "زیرزمین" : <>طبقه {e2p(props.data?.floor?.toString())}</>}
                  </span>
                </div>
              </div>
            )}

            {props.limitedFields?.find(item => item === "Floor") ||
            shopCategories.includes(getCategoryParent()) ||
            hotelCategories.includes(getCategoryParent()) ||
            gasStationCategories.includes(getCategoryParent()) ||
            landCategories.includes(getCategoryParent()) ? (
              <></>
            ) : (
              <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                  <img src={buildingIcon} alt="icon" />
                </div>
                <div className="d-flex align-items-start justify-content-center flex-column me-3">
                  <span className={styles.text_gray}>تعداد طبقه</span>
                  <span className={`me-0 mt-1 ${styles.card_main_detail_text2}`}>{e2p(props.data?.totalFloors)}</span>
                </div>
              </div>
            )}

            {props.limitedFields?.find(item => item === "ConstructionYear") ||
            shopCategories.includes(getCategoryParent()) ||
            shopCategories.includes(getCategoryParent()) ||
            hotelCategories.includes(getCategoryParent()) ||
            gasStationCategories.includes(getCategoryParent()) ||
            landCategories.includes(getCategoryParent()) ? (
              <></>
            ) : (
              <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
                <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                  <img src={calenderIcon} alt="icon" />
                </div>
                <div className="d-flex align-items-start justify-content-center flex-column me-3">
                  <span className={styles.text_gray}>سال ساخت</span>
                  <span className={`me-0 mt-1 ${styles.text_title_sm}`}>{e2p(props.data?.constructionYear?.toString())}</span>
                </div>
              </div>
            )}
            <div className={`d-flex align-items-center justify-content-center my-md-0 my-3 mx-md-0 mx-3 ${styles.facilities_card_container}`}>
              <div className={`d-flex align-items-center justify-content-center ${styles.icon_bg}`}>
                <img src={locationIcon} alt="icon" />
              </div>
              <div className="d-flex align-items-start justify-content-center flex-column me-3">
                <span className={styles.text_gray}>منطقه</span>
                <span className={`me-0 mt-1 ${styles.text_title_sm}`}>{e2p(props.data?.address.zone?.toString())}</span>
              </div>
            </div>
          </div>
          <hr className="solid w-100" />
          {/* </div> */}
        </div>

        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
          {props.limitedFields?.find(item => item === "Facilities") ? (
            <></>
          ) : (
            <div className="w-100 d-flex align-items-center justify-content-center flex-column flex-wrap mt-3 px-3">
              <div className="w-100 d-flex align-items-center justify-content-md-start justify-content-center">
                <div className={styles.file_title}>سایر امکانات</div>
              </div>
              <FileFacilities
                addedFacilities={props.addedFacilities}
                setAddedFacilities={props.setAddedFacilities}
                facilitiData={props.facilitiData}
                itemID={props.facilitiData}
                addedFacilitiesID={props.addedFacilitiesID}
                setAddedFacilitiesID={props.setAddedFacilitiesID}
                cardData={props?.data}
              />
            </div>
          )}
        </div>

        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
          {/* description */}
          <div className="w-100 d-flex align-items-center justify-content-center flex-wrap mt-3 mb-3 px-3">
            {props.limitedFields?.find(item => item === "Description") ? (
              <></>
            ) : (
              <div className={`w-100 p-3 text-right ${styles.about_ad}`}>
                {/* {e2p(props.data?.description)} */}
                {props.data?.description ? parse(`<body className=${styles.body_container}>${props.data?.description}</body>`) : parse("")}
              </div>
            )}
          </div>
          {/* description */}
        </div>

        <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mb-3">
          <div className="w-100 d-flex align-items-center justify-content-center flex-wrap mt-4 mb-4 px-3">
            <div className={`w-100 d-flex align-items-center justify-content-center flex-wrap mt-3 mb-3 px-2 ${styles.chart_container}`}>
              <div className="w-100 d-flex align-items-center justify-content-md-start justify-content-center mb-4 me-3 mt-3">
                <div className={styles.card_title}>نمودار تغییر قیمت</div>
              </div>
              <CardChart data={props.chartData} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserFilesDetailFacilities;
